<template>
  <div class="index">
    <img src="http://prod.resource.china-pcs.com/rtas/20191217/1576554971536_18.jpg">
  </div>
</template>

<script>
    export default {
        name: "系统首页"
    }
</script>

<style scoped>
  .index{
    width: 100%;
    height: calc(100% - 35px);
  }
  .index img{
    width: 100%;
    height: 99%;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue